module.exports = __webpack_public_path__ + "img/util-tab-2.c248bf76.svg";